export default "__VITE_ASSET__BR2lMl2F__"